import { jsx as _jsx, jsxs as _jsxs } from "tsx-dom/jsx-runtime";
/**
 * @returns The HTMLElement containing the list of save files
 */
export function SaveManager() {
    return (_jsx("div", { id: "save-manager", class: "modal hidden", children: _jsxs("div", { id: "modal-area", class: "modal-area", children: [_jsx("span", { class: "close-modal" }), _jsx("div", { class: "general-save-options", children: _jsx("span", { class: "modal-button" }) }), _jsx("table", { id: "local-saves" })] }) }));
}
